// Mock data for Unya Mee platform

export const translations = {
  en: {
    // Navigation
    home: 'Home',
    workshops: 'Workshops',
    shop: 'Shop',
    about: 'About',
    contact: 'Contact',
    
    // Hero section
    heroTitle: 'Where Waste Becomes Wonder',
    heroSubtitle: 'Upcycling fashion born from intuition, handmade processes, and the transformation of textile waste into meaningful objects',
    heroCtaWorkshops: 'Join a Workshop',
    heroCtaShop: 'Explore One-of-a-Kind Pieces',
    
    // Why Upcycling section
    whyTitle: 'Why Upcycling Matters Now',
    whyText: 'The fashion industry produces 92 million tons of textile waste every year. We believe in a different path—one where every fabric has a story, where imperfection is beauty, and where your clothes remember and transform. Unya Mee is not fast fashion. It\'s a slow revolution stitched with care.',
    
    // What Makes Us Unique
    uniqueTitle: 'What Makes Unya Mee Workshops Unique',
    uniqueSubtitle: 'More than technique—a creative transformation',
    unique1Title: 'Intuition Over Rules',
    unique1Text: 'No rigid patterns. We follow feeling, emotion, and the raw beauty of imperfection.',
    unique2Title: 'Small Groups, Safe Space',
    unique2Text: 'Intimate workshops where experimentation is celebrated and mistakes become opportunities.',
    unique3Title: 'Sustainability Through Practice',
    unique3Text: 'Learn to see waste as material, to give garments new voices, to create meaning from what was left behind.',
    unique4Title: 'For Everyone',
    unique4Text: 'Beginners, artists, designers, people afraid of sewing—all are welcome here.',
    
    // Workshop page
    workshopsHeroTitle: 'Transform Through Making',
    workshopsHeroSubtitle: 'Intimate workshops where textile waste becomes art, and sewing becomes meditation',
    workshopBookNow: 'Book & Pay Now',
    workshopDuration: 'Duration',
    workshopLocation: 'Location',
    workshopLanguage: 'Language',
    workshopPrice: 'Price',
    workshopMaterials: 'Materials Included',
    workshopWhoFor: 'Who It\'s For',
    
    // Shop page
    shopHeroTitle: 'One-of-a-Kind Objects',
    shopHeroSubtitle: 'Each piece is unique, crafted from secondhand and leftover materials. Nothing is random—each fabric has its own past, and we give it a new voice.',
    shopAddToCart: 'Add to Cart',
    shopSize: 'Size',
    shopMaterial: 'Material',
    shopStory: 'Story',
    
    // About page
    aboutTitle: 'Our Story',
    aboutSubtitle: 'Fashion that speaks, remembers, and transforms',
    
    // Contact page
    contactTitle: 'Let\'s Create Together',
    contactSubtitle: 'Book a workshop, ask about custom pieces, or simply say hello',
    contactName: 'Name',
    contactEmail: 'Email',
    contactPhone: 'Phone',
    contactMessage: 'Message',
    contactSend: 'Send Message',
    contactInfo: 'Contact Information',
    
    // Footer
    footerTagline: 'Sustainable fashion born from intuition',
    footerRights: 'All rights reserved',
  },
  pl: {
    // Navigation
    home: 'Strona główna',
    workshops: 'Warsztaty',
    shop: 'Sklep',
    about: 'O nas',
    contact: 'Kontakt',
    
    // Hero section
    heroTitle: 'Gdzie Odpady Stają Się Cudem',
    heroSubtitle: 'Moda upcyklingowa rodząca się z intuicji, ręcznych procesów i transformacji tekstylnych odpadów w znaczące obiekty',
    heroCtaWorkshops: 'Dołącz do Warsztatów',
    heroCtaShop: 'Zobacz Unikalne Rzeczy',
    
    // Why Upcycling section
    whyTitle: 'Dlaczego Upcykling Jest Teraz Ważny',
    whyText: 'Przemysł modowy produkuje 92 miliony ton odpadów tekstylnych rocznie. Wierzymy w inną ścieżkę—taką, gdzie każda tkanina ma swoją historię, gdzie niedoskonałość jest pięknem, a twoje ubrania pamiętają i transformują się. Unya Mee to nie fast fashion. To powolna rewolucja szyta z troską.',
    
    // What Makes Us Unique
    uniqueTitle: 'Co Czyni Warsztaty Unya Mee Wyjątkowymi',
    uniqueSubtitle: 'Więcej niż technika—kreatywna transformacja',
    unique1Title: 'Intuicja Ponad Zasady',
    unique1Text: 'Bez sztywnych wzorów. Podążamy za uczuciem, emocją i surowym pięknem niedoskonałości.',
    unique2Title: 'Małe Grupy, Bezpieczna Przestrzeń',
    unique2Text: 'Kameralne warsztaty, gdzie eksperymentowanie jest celebrowane, a błędy stają się możliwościami.',
    unique3Title: 'Zrównoważony Rozwój Poprzez Praktykę',
    unique3Text: 'Naucz się widzieć odpady jako materiał, dawać ubraniom nowe głosy, tworzyć znaczenie z tego, co zostało pozostawione.',
    unique4Title: 'Dla Każdego',
    unique4Text: 'Początkujący, artyści, projektanci, ludzie bojący się szycia—wszyscy są tu mile widziani.',
    
    // Workshop page
    workshopsHeroTitle: 'Transformuj Poprzez Tworzenie',
    workshopsHeroSubtitle: 'Kameralne warsztaty, gdzie tekstylne odpady stają się sztuką, a szycie medytacją',
    workshopBookNow: 'Zarezerwuj i Zapłać',
    workshopDuration: 'Czas trwania',
    workshopLocation: 'Lokalizacja',
    workshopLanguage: 'Język',
    workshopPrice: 'Cena',
    workshopMaterials: 'Materiały wliczone',
    workshopWhoFor: 'Dla kogo',
    
    // Shop page
    shopHeroTitle: 'Unikalne Obiekty',
    shopHeroSubtitle: 'Każdy element jest unikalny, stworzony z używanych i pozostałych materiałów. Nic nie jest przypadkowe—każda tkanina ma swoją przeszłość, a my dajemy jej nowy głos.',
    shopAddToCart: 'Dodaj do koszyka',
    shopSize: 'Rozmiar',
    shopMaterial: 'Materiał',
    shopStory: 'Historia',
    
    // About page
    aboutTitle: 'Nasza Historia',
    aboutSubtitle: 'Moda, która mówi, pamięta i transformuje',
    
    // Contact page
    contactTitle: 'Twórzmy Razem',
    contactSubtitle: 'Zarezerwuj warsztat, zapytaj o niestandardowe rzeczy lub po prostu przywitaj się',
    contactName: 'Imię',
    contactEmail: 'Email',
    contactPhone: 'Telefon',
    contactMessage: 'Wiadomość',
    contactSend: 'Wyślij Wiadomość',
    contactInfo: 'Informacje Kontaktowe',
    
    // Footer
    footerTagline: 'Zrównoważona moda rodząca się z intuicji',
    footerRights: 'Wszelkie prawa zastrzeżone',
  }
};

export const mockWorkshops = [
  {
    id: 1,
    title: { en: 'Intuitive Sewing: Beyond the Pattern', pl: 'Intuicyjne Szycie: Poza Wykrojem' },
    description: { 
      en: 'Learn to sew without rigid rules. Follow your intuition, embrace imperfection, and discover the raw beauty of handmade creation. This workshop is about feeling your way through fabric, trusting your hands, and creating something uniquely yours.',
      pl: 'Naucz się szyć bez sztywnych zasad. Podążaj za intuicją, obejmij niedoskonałość i odkryj surowe piękno ręcznego tworzenia. Ten warsztat dotyczy wyczuwania drogi przez tkaniny, ufania swoim rękom i tworzenia czegoś wyjątkowo twojego.'
    },
    duration: { en: '4 hours', pl: '4 godziny' },
    location: 'Warsaw',
    language: { en: 'English / Polish', pl: 'Angielski / Polski' },
    price: 250,
    currency: 'PLN',
    materials: { 
      en: 'All sewing materials, textile waste, thread, needles, and tools provided',
      pl: 'Wszystkie materiały do szycia, odpady tekstylne, nici, igły i narzędzia zapewnione'
    },
    whoFor: { 
      en: 'Anyone curious about sewing. No experience needed—just an open mind and willing hands.',
      pl: 'Każdy ciekawy szycia. Żadne doświadczenie nie jest potrzebne—tylko otwarty umysł i chętne ręce.'
    },
    image: 'https://images.unsplash.com/photo-1558769132-cb1aea9c6a0d?w=800'
  },
  {
    id: 2,
    title: { en: 'Upcycling Mastery: Transformation Workshop', pl: 'Mistrzostwo Upcyklingu: Warsztat Transformacji' },
    description: { 
      en: 'Turn forgotten garments into statement pieces. Learn advanced upcycling techniques: deconstructing, reconstructing, dyeing, patching, and creating art from what others discard. This is where waste meets wonder.',
      pl: 'Zmień zapomniane ubrania w charakterystyczne elementy. Naucz się zaawansowanych technik upcyklingu: dekonstrukcji, rekonstrukcji, farbowania, łatania i tworzenia sztuki z tego, co inni wyrzucają. To tutaj odpady spotykają się z cudem.'
    },
    duration: { en: '6 hours', pl: '6 godzin' },
    location: 'Warsaw',
    language: { en: 'English / Polish', pl: 'Angielski / Polski' },
    price: 380,
    currency: 'PLN',
    materials: { 
      en: 'Second-hand garments, upcycling materials, dyes, tools, and creative supplies',
      pl: 'Używane ubrania, materiały do upcyklingu, farby, narzędzia i kreatywne zapasy'
    },
    whoFor: { 
      en: 'For makers, artists, and anyone who sees beauty in transformation. Some sewing experience helpful but not required.',
      pl: 'Dla twórców, artystów i każdego, kto widzi piękno w transformacji. Pewne doświadczenie w szyciu pomocne, ale nie wymagane.'
    },
    image: 'https://images.unsplash.com/photo-1618453292459-5eaa6a5f761a?w=800'
  },
  {
    id: 3,
    title: { en: 'Slow Fashion Philosophy: Create Your Signature Piece', pl: 'Filozofia Slow Fashion: Stwórz Swoją Charakterystyczną Rzecz' },
    description: { 
      en: 'A deeply personal workshop where you create one meaningful garment from start to finish. We explore slowness, intention, and the philosophy of creating clothes that tell your story. Less about technique, more about connection.',
      pl: 'Głęboko osobisty warsztat, podczas którego tworzysz jeden znaczący ubiór od początku do końca. Eksplorujemy powolność, intencję i filozofię tworzenia ubrań, które opowiadają twoją historię. Mniej o technice, więcej o połączeniu.'
    },
    duration: { en: '8 hours (2 sessions)', pl: '8 godzin (2 sesje)' },
    location: 'Warsaw',
    language: { en: 'English / Polish', pl: 'Angielski / Polski' },
    price: 500,
    currency: 'PLN',
    materials: { 
      en: 'Curated textile selection, all materials, tea, and a meditative creative space',
      pl: 'Wyselekcjonowany wybór tekstyliów, wszystkie materiały, herbata i medytacyjna kreatywna przestrzeń'
    },
    whoFor: { 
      en: 'For those seeking more than a skill—a practice. Open to all levels who want to slow down and create with meaning.',
      pl: 'Dla tych, którzy szukają więcej niż umiejętności—praktyki. Otwarte dla wszystkich poziomów, którzy chcą zwolnić i tworzyć ze znaczeniem.'
    },
    image: 'https://images.unsplash.com/photo-1617038220319-276d3cfab638?w=800'
  }
];

export const mockProducts = [
  {
    id: 1,
    title: { en: 'Ocean Moonlight Dress', pl: 'Sukienka Ocean Moonlight' },
    price: 550,
    currency: 'PLN',
    size: { en: 'One size (adjustable)', pl: 'Jeden rozmiar (regulowany)' },
    material: { 
      en: 'Upcycled lace, vintage cotton, hand-dyed silk remnants',
      pl: 'Upcyklingowana koronka, vintage bawełna, ręcznie farbowane resztki jedwabiu'
    },
    story: { 
      en: 'Born from three forgotten fabrics found in Warsaw flea markets. The lace remembers grandmother\'s tablecloths, the cotton tells stories of summer dresses, and the silk once adorned evening gowns. Now they dance together as one.',
      pl: 'Zrodzona z trzech zapomnianych tkanin znalezionych na warszawskich pchlich targach. Koronka pamięta obrusy babci, bawełna opowiada historie letnich sukienek, a jedwab kiedyś zdobiły wieczorowe suknie. Teraz tańczą razem jako jeden.'
    },
    image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=800',
    available: true
  },
  {
    id: 2,
    title: { en: 'Patch Vibe Energy Top', pl: 'Top Patch Vibe Energy' },
    price: 200,
    currency: 'PLN',
    size: { en: 'S-M', pl: 'S-M' },
    material: { 
      en: 'Patchwork of denim, corduroy, vintage tees, hand-stitched',
      pl: 'Patchwork z denimu, sztruksu, vintage koszulek, ręcznie zszyty'
    },
    story: { 
      en: 'Every patch is a rebellion. Scraps from jeans that walked city streets, shirts that absorbed concerts and protests, fabrics that lived lives before becoming this. Wear it as armor or as art.',
      pl: 'Każdy kawałek to bunt. Skrawki dżinsów, które chodziły po ulicach miasta, koszul, które wchłonęły koncerty i protesty, tkaniny, które żyły życiem, zanim stały się tym. Noś to jako zbroję lub jako sztukę.'
    },
    image: 'https://images.unsplash.com/photo-1564584217132-2271feaeb3c5?w=800',
    available: true
  },
  {
    id: 3,
    title: { en: 'Inside Out Impact Jacket', pl: 'Kurtka Inside Out Impact' },
    price: 600,
    currency: 'PLN',
    size: { en: 'L (unisex)', pl: 'L (uniseks)' },
    material: { 
      en: 'Reversible wool blend, exposed seams, upcycled winter coat fragments',
      pl: 'Dwustronna mieszanka wełny, odsłonięte szwy, upcyklingowane fragmenty zimowego płaszcza'
    },
    story: { 
      en: 'This jacket shows its bones. Seams outside, construction visible, honesty in every stitch. Made from a coat someone left behind at a thrift store. Now it\'s art you can wear two ways. Choose your mood.',
      pl: 'Ta kurtka pokazuje swoje kości. Szwy na zewnątrz, konstrukcja widoczna, uczciwość w każdym ściegu. Wykonana z płaszcza, który ktoś zostawił w sklepie charytatywnym. Teraz to sztuka, którą możesz nosić na dwa sposoby. Wybierz swój nastrój.'
    },
    image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800',
    available: true
  },
  {
    id: 4,
    title: { en: 'Sleeveless Chaos Knit', pl: 'Dzianina Sleeveless Chaos' },
    price: 150,
    currency: 'PLN',
    size: { en: 'One size', pl: 'Jeden rozmiar' },
    material: { 
      en: 'Hand-knitted from leftover yarn, mixed textures and colors',
      pl: 'Ręcznie dziergana z pozostałej przędzy, mieszane tekstury i kolory'
    },
    story: { 
      en: 'Knitted slowly over winter evenings. Every color is a different yarn rescued from abandoned projects. Chaos organized into wearable art. Imperfectly perfect.',
      pl: 'Dzierżone powoli podczas zimowych wieczorów. Każdy kolor to inna przędza uratowana z porzuconych projektów. Chaos zorganizowany w noszalne dzieło sztuki. Niedoskonale doskonały.'
    },
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?w=800',
    available: false
  }
];